import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const T = {
  label: { cs: "Opište kód z obrázku", en: "Type the code from the image" },
  ph: { cs: "Kód", en: "Code" },
  refresh: { cs: "Nový kód", en: "New code" },
  fail: { cs: "Kód se nepodařilo načíst — zkuste obnovit", en: "Couldn't load the code — try refresh" },
};

export const CaptchaField = ({ onChange, inputCls, refreshSignal = 0, testidPrefix = "captcha" }) => {
  const { lang } = useLanguage();
  const [cap, setCap] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    setFailed(false);
    try {
      const r = await axios.get(`${API}/captcha`);
      setCap(r.data);
      onChange(r.data.captchaId, "");
    } catch {
      setCap(null);
      setFailed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshSignal]);

  return (
    <div data-testid={`${testidPrefix}-field`}>
      <p className="text-xs font-semibold text-slate-400">{T.label[lang]}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2.5">
        {cap ? (
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}${cap.imageUrl}`}
            onError={(e) => { console.warn("captcha image URL failed, falling back to base64"); e.currentTarget.onerror = null; e.currentTarget.src = cap.image; }}
            alt="captcha"
            data-testid={`${testidPrefix}-image`}
            className="h-14 w-[140px] shrink-0 rounded-lg border border-teal-400/25"
          />
        ) : failed ? (
          <div className="flex h-14 w-[160px] items-center justify-center rounded-lg border border-red-400/30 bg-red-400/5 px-2 text-center text-[10px] font-semibold text-red-300" data-testid={`${testidPrefix}-error`}>
            {T.fail[lang]}
          </div>
        ) : (
          <div className="h-14 w-[160px] animate-pulse rounded-lg border border-teal-400/25 bg-white/5" data-testid={`${testidPrefix}-loading`} />
        )}
        <button
          type="button"
          onClick={load}
          data-testid={`${testidPrefix}-refresh`}
          aria-label={T.refresh[lang]}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-teal-400/25 text-teal-300 transition-colors duration-200 hover:bg-teal-400/10"
        >
          <RefreshCw size={15} />
        </button>
        <input
          autoComplete="off"
          maxLength={5}
          onChange={(e) => onChange(cap?.captchaId || null, e.target.value)}
          placeholder={T.ph[lang]}
          className={`${inputCls} min-w-[110px] max-w-[140px] flex-1 font-mono uppercase tracking-[0.3em]`}
          data-testid={`${testidPrefix}-input`}
        />
      </div>
    </div>
  );
};
